import {
	SeasonKey,
	GroudnutSeasonKey,
	PaddySeasonKey,
	PotatoSeasonKey,
} from 'modules/CommonView/seasonsConfig';

export const GROUNDNUT_SEASON_ID_MAP: Record<string, GroudnutSeasonKey> = {
	'324': 'GROUNDNUT_2025',
};
export const SUGARCANE_SEASON_ID_MAP: Record<string, SeasonKey> = {
	'323': 'SUGARCANE_2024',
};
export const PADDY_SEASON_ID_MAP: Record<string, PaddySeasonKey> = {
	'327': 'PADDY_2025',
};
export const POTATO_SEASON_ID_MAP: Record<string, PotatoSeasonKey> = {
	'332': 'POTATO_2025',
};

type SeasonConfig =
	| typeof GROUNDNUT_SEASON_ID_MAP
	| typeof SUGARCANE_SEASON_ID_MAP
	| typeof PADDY_SEASON_ID_MAP
	| typeof POTATO_SEASON_ID_MAP;

export const getSeasonIdMapByType = (type: string): SeasonConfig | {} => {
	switch (type?.toLowerCase()) {
		case 'groundnut':
			return GROUNDNUT_SEASON_ID_MAP;
		case 'sugarcane':
			return SUGARCANE_SEASON_ID_MAP;
		case 'paddy':
			return PADDY_SEASON_ID_MAP;
		case 'potato':
			return POTATO_SEASON_ID_MAP;
		default:
			return {};
	}
};
